<template lang="">
<div class="contents">
    <div class="customer_wrap">
        <div class="cs_card">
            <div class="box">
                <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                <p>고객센터 이용안내</p>
                <h5>070.4233.0655</h5>
                <span>FAX : 02)478-5822</span>
            </div>
            <p>운영시간</p>
            <span>월-금 09:00~17:30</span>
        </div>
        <div class="cs_tab">
            <CustomerServiceNavigation/>
            <div class="cs_tabPanel active" id="cs_tab03">
                <h5 class="title">1:1문의</h5>
                <div class="tbl_wrap">
                    <table class="write inquiry">
                        <tbody>
                            <tr>
                                <th>
                                    분류
                                </th>
                                <td>
                                    <SelectList
                                        v-model="userType"
                                        :options="userOptions"
                                        unit=""
                                        selectClass="select_box"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    제목
                                </th>
                                <td>
                                    <input type="text" class="tit" v-model="questionTitle">
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    문의내용
                                </th>
                                <td>
                                    <textarea v-model="questionContent"></textarea>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    이메일
                                </th>
                                <td>
                                    <div class="emailWrap">
                                        <input type="text" v-model="email.emailFirst">
                                        <span>@</span>
                                        <input type="text" v-model="email.emailLast" :disabled="emailSelf !== '직접입력'">
                                        <SelectList v-model="emailSelf" :options="emailOptions" unit="" selectClass="select_box"/>

                                    </div>
                                    <!-- <div class="form_wrap">
                                        <label for="receive" class="radio_wrap">
                                            <input type="radio" value="Y" name="receive" v-model="emailReceive">
                                            <span>이메일로 받음</span>
                                        </label>
                                        <label for="Notreceive" class="radio_wrap">
                                            <input type="radio" value="N" name="receive" v-model="emailReceive">
                                            <span>이메일로 받지 않음</span>
                                        </label>
                                    </div> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="inquiry_txt">
                    · 고객님의 문의 내용에 대한 답변은 이메일과 <span>마이페이지 > 1:1문의</span> 내역에서 확인하실 수 있습니다.
                </div>
                <div class="btn_wrap">
                    <button type="button" class="btn_cancel">취소</button>
                    <button type="button" class="btn_check" @click="createInquiry">확인</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';
import SelectList from '../common/SelectList.vue';
import { mapActions } from 'vuex';

const inquiryModule = 'inquiryModule'

export default {
    components: {
        CustomerServiceNavigation,
        SelectList
    },

    data() {
        return {
            userType: '회원',
            userOptions: ['회원', '비회원'],

            questionTitle: '',
            questionContent: '',

            emailReceive: 'Y',

            email: {
                emailFirst: '',
                emailLast: ''
            },
            emailSelf: '직접입력',
            emailOptions: [
                '직접입력',
                'naver.com',
                'gmail.com'
            ],
        }
    },

    methods: {
        ...mapActions(inquiryModule, ['requestCreateInquiry']),

        async createInquiry() {
            const isValid = this.validation()
            if (isValid) {
                this.$openModal('alertModal', {
                    message: isValid
                })
                return
            }

            var userEmail = ''
            if (this.email.emailFirst.length < 1 || this.email.emailLast.length < 1) {
                userEmail = ''
            } else {
                userEmail = this.email.emailFirst + '@' + this.email.emailLast
            }
            const questionContent = this.questionContent.replace(/\n/g, '<br>')
            const {userType, questionTitle, emailReceive} = this
            if (await this.requestCreateInquiry({userType, questionTitle, questionContent, emailReceive, userEmail})) {
                this.$openModal('alertModal', {
                    message: "문의가 등록 되었습니다."
                })
                this.$router.push({ name: 'home' })
            }
        },

        validation() {
            if (this.questionTitle.length < 1) return '제목을 입력해 주세요.'
            if (this.questionContent.length < 1) return '내용을 입력해 주세요.'
            if (this.userType === '비회원' && (this.email.emailFirst.length < 1 || this.email.emailLast.length < 1)) return '이메일을 입력해 주세요.'
        }
    },

    watch: {
        emailSelf: {
            handler(newVal) {
                if (newVal !== '직접입력') {
                    this.email.emailLast = newVal
                } else {
                    this.email.emailLast = ''
                }
            }
        },
    }

}
</script>
<style lang="">

</style>